import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TTicketingUserInvitation } from '../types/ticketing-user.type';

export const InviteAsAdminTicketingInvitationValidationSchema = z.object({
  fullname: z.string({ message: 'Fullname is required' }).min(1),
  email: z.string({ message: 'Email is required' }).min(1),
});

export type TInviteAsAdminTicketingInvitationValidation = z.infer<
  typeof InviteAsAdminTicketingInvitationValidationSchema
>;
export type TInviteAsAdminTicketingInvitationPayload = TInviteAsAdminTicketingInvitationValidation;
export type TInviteAsAdminTicketingInvitationResponse = ApiResponse<TTicketingUserInvitation>;

export const inviteAsAdminTicketingUserInvitation = async (
  payload: TInviteAsAdminTicketingInvitationPayload
): Promise<TInviteAsAdminTicketingInvitationResponse> => {
  const url = `/invitation-ticketing`;

  return axiosInstance.post(url, payload);
};

/**
 * Use Invite As Admin Ticketing User Invitation React-Query Hook
 */
type UseInviteAsAdminTicketingUserInvitationMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof inviteAsAdminTicketingUserInvitation, AxiosErrorCustom>;
};

/**
 * Use Invite As Admin Ticketing User Invitation React-Query Hook
 */
export const useInviteAsAdminTicketingUserInvitationMutation = ({
  mutationConfig,
}: UseInviteAsAdminTicketingUserInvitationMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: inviteAsAdminTicketingUserInvitation,
    ...restConfig,
  });
};
